import React from 'react';
import { fTimeDateNewLine } from '@/actions/Helper';

const DateCell = ({ date, isExpired = false }) => {
  if (!date) return '-';

  const dateTime = fTimeDateNewLine(date);
  return (
    <div className={`flex flex-col ${isExpired ? 'text-red-500' : ''}`}>
      <div>{dateTime.date}</div>
      <div>{dateTime.time}</div>
    </div>
  );
};

export default DateCell;
